export default __webpack_public_path__ + "static/media/worry-free-maintenance.106f83d3.png";